export default "public/CompliCare.png";